'use strict';

import {pictures, places, sityInfroStruct, mapHelper} from "./yMap/yMapHelper";

var map = null;

let geoObjectsContactsCollections = {};
let placesContactsCollection = {};

function initmap() {
  // location map
  map = new ymaps.Map("YMapsIDContacts", {
    center: pictures.skyhouse.coordinates,
    zoom: 14,
    controls: ['zoomControl']
  });
  mapHelper.createPicturesCollection(map);

  placesContactsCollection = mapHelper.createPlacesColletion();
  map.geoObjects.add(placesContactsCollection);

  for (const i in sityInfroStruct) {
    geoObjectsContactsCollections[i] = mapHelper.createGeoObjectsByType(i);
    map.geoObjects.add(geoObjectsContactsCollections[i]);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ymaps.ready(initmap);
});
